import gql from 'graphql-tag';
import { donorFragments } from './donors.queries';

export const GET_ORGANIZATION_DONORS_REPORT = gql`
  query getOrganizationDonorsReport(
    $page: Int
    $limit: Int
    $dateRangeStart: String
    $dateRangeEnd: String
    $amount: Float
    $amountPredicate: Predicate
    $isRevvUser: Boolean
    $search: String
    $organizationRevvUid: String
    $contributorType: [ContributorTypeEnum!]
    $ignoreCustomFields: Boolean
  ) {
    viewer {
      state_level_organization(revvUid: $organizationRevvUid) {
        export_donors_report(
          filters: {
            page: $page
            limit: $limit
            amount: $amount
            amountPredicate: $amountPredicate
            dateRangeStart: $dateRangeStart
            dateRangeEnd: $dateRangeEnd
            isRevvUser: $isRevvUser
            search: $search
            contributorType: $contributorType
            ignoreCustomFields: $ignoreCustomFields
          }
        )
      }
    }
  }
`;

export const GET_ORGANIZATION_DONORS_QUERY = gql`
  query getOrganizationDonors(
    $page: Int
    $limit: Int
    $dateRangeStart: String
    $dateRangeEnd: String
    $organizationRevvUid: String
    $amount: Float
    $amountPredicate: Predicate
    $isRevvUser: Boolean
    $search: String
    $contributorType: [ContributorTypeEnum!]
  ) {
    viewer {
      state_level_organization(revvUid: $organizationRevvUid) {
        donors(
          filters: {
            page: $page
            limit: $limit
            amount: $amount
            amountPredicate: $amountPredicate
            dateRangeStart: $dateRangeStart
            dateRangeEnd: $dateRangeEnd
            isRevvUser: $isRevvUser
            search: $search
            contributorType: $contributorType
          }
        ) {
          ...Donors
        }
      }
    }
  }
  ${donorFragments.donors}
`;

export const GET_ORGANIZATION_DONOR_QUERY = gql`
  query getOrganizationDonor($revv_uid: String, $organizationRevvUid: String) {
    viewer {
      state_level_organization(revvUid: $organizationRevvUid) {
        donors(filters: { revvUid: $revv_uid }) {
          ...Donor
        }
      }
    }
  }
  ${donorFragments.donor}
`;
